import { render, staticRenderFns } from "./CardContactDialog.vue?vue&type=template&id=37e1e59e&scoped=true"
import script from "./CardContactDialog.vue?vue&type=script&lang=ts"
export * from "./CardContactDialog.vue?vue&type=script&lang=ts"
import style0 from "./CardContactDialog.vue?vue&type=style&index=0&id=37e1e59e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1e59e",
  null
  
)

export default component.exports